import { render } from "./StaticPage.vue?vue&type=template&id=075983d0&scoped=true"
import script from "./StaticPage.vue?vue&type=script&lang=js"
export * from "./StaticPage.vue?vue&type=script&lang=js"

import "./StaticPage.vue?vue&type=style&index=0&id=075983d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-075983d0"]])

export default __exports__